<template>
  <div class="main-wrapper" :class="[mainWrapperClass]">
    <!---Navigation-->
    <Navbar
      :topbarColor="topbarColor"
      @click="$router.push('/dashboard')"
      :logo="require('@/assets/images/logo/nowe/logo-white.svg')"
    />
    <!---Sidebar-->
    <!-- <SideBar parent=".main-wrapper" :sidebarLinks="sidebarLinks"/> -->
    <!---Page Container-->
    <div class="main-container-fluid">
      <Breadcrumb />
      <transition
        name="router-anim"
        enter-active-class="fade-enter-active fade-enter"
        leave-active-class="fade-leave-active fade-enter"
      >
        <router-view></router-view>
      </transition>
      <!---Customizer / Settings-->
      <!-- <Customizer @updateTopbarColor="updateTopbarColor" /> -->
    </div>
    <cookie-law theme="base" buttonText="Rozumiem">
      <div slot="message">Strona nie wykorzystuje technologii plików cookies.</div>
    </cookie-law>
  </div>
</template>

<script>
import Navbar from "@/layout/full/header/Navbar.vue";
// import Customizer from '@/layout/full/customizer/Customizer.vue';
import Breadcrumb from "@/layout/full/breadcrumb/Breadcrumb.vue";
import CookieLaw from 'vue-cookie-law';
import themeConfig from "@/../themeConfig.js";

export default {
  name: "MainContainer",
  components: {
    Navbar,
    // Customizer,
    Breadcrumb,
    CookieLaw
  },
  data: () => ({
    topbarColor: themeConfig.topbarColor,
    logotitle: themeConfig.logotitle
  }),
  methods: {
    updateTopbarColor(val) {
      this.topbarColor = val;
    }
  },
  computed: {
    sidebarWidth: function() {
      return this.$store.state.sidebarWidth;
    },
    mainWrapperClass: function() {
      return "default";
    }
  }
};
</script>
